import { Box, Image, Link } from 'theme-ui'

import Type from 'src/components/gel/Type'
import Icon from 'src/components/gel/Icon'
import NewsletterFooter from 'src/components/newsletter/NewsletterFooter'
import { defaultClickEvent } from 'src/lib/analytics'

const ExternalLink = ({ url, text }: { url: string; text: string }) => {
  return (
    <Link
      variant="primary"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ display: 'flex', mr: 6 }}
      onClick={() => {
        defaultClickEvent({
          event_grouping: 'footer',
          item_name: text,
          item_type: 'link',
          item_link: url
        })
      }}
    >
      <Icon variant="GelIconExternalLink" sx={{ mr: 2, verticalAlign: 'middle' }} />
      <Type variant="MetaData" sx={{ alignContent: 'center' }}>
        {text}
      </Type>
    </Link>
  )
}

const Footer = ({ withNewsletter = false }: { withNewsletter?: boolean }) => (
  <Box>
    {withNewsletter && <NewsletterFooter />}
    <Box
      as="footer"
      sx={{ px: [2, null, 4], pt: [6, null, 7], pb: 6, backgroundColor: 'background.quaternary' }}
    >
      <Image
        src="/images/BBC_STUDIOS_SingleLine.svg"
        alt="BBC Studios logo"
        sx={{ height: '28px', mb: 7 }}
      />
      <Box as="div" sx={{ display: 'flex', flexWrap: 'wrap', rowGap: 4, mb: 4 }}>
        <ExternalLink url="https://www.bbc.com/" text="BBC.com" />
        <ExternalLink url="https://www.bbc.com/storyworks" text="BBC Storyworks" />
        <ExternalLink url="https://www.bbcstudios.com/privacy" text="Privacy Policy" />
        <ExternalLink url="https://www.bbcstudios.com/terms-conditions" text="Site Terms" />
        <ExternalLink url="https://www.bbcstudios.com/copyright" text="Copyright" />
        <ExternalLink url="https://www.bbcstudios.com/cookies" text="Cookies Policy" />
        <Box
          as="button"
          data-cc="show-preferencesModal"
          sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          className="tabFocusBlue"
          onClick={e => {
            e.preventDefault()
            defaultClickEvent({
              event_grouping: 'footer',
              item_name: 'Cookies Preferences',
              item_type: 'link',
              item_link: '#cookiesPreferences'
            })
          }}
        >
          <Type variant="MetaData">Cookies Preferences</Type>
        </Box>
      </Box>
      <Box
        as="div"
        sx={{
          textAlign: 'left',
          borderTop: 'tertiaryThin',
          paddingTop: 4
        }}
      >
        <Type variant="MetaData" sx={{ maxWidth: '800px', color: 'text.secondary' }}>
          This website is made by BBC Studios Distribution. BBC Studios is a commercial company that
          is owned by the BBC (and just the BBC). No money from the licence fee was used to create
          this website. The profits we make from it go back to BBC programme-makers to help fund
          great new BBC programmes. BBC is a trademark of the British Broadcasting Corporation.
          Logos © 1996.
        </Type>
      </Box>
    </Box>
  </Box>
)

export default Footer
